<template>
    <div>
        <div class="page-top mb-1 mb-3 align-center clearfix">
            <h1 class="float-left"> My Payments </h1>
        </div>
        <table id="myPaymentsTable" class="table" style="width:100%">
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Salary</th>
                    <th>Additional Earnings</th>
                    <th>Reimbursements</th>
                    <th>Deductions</th>
                    <th>Transaction</th>
                    <th>Net Payable</th>
                    <th>Date</th>
                    <th>Download</th>
                </tr>
            </thead>
        </table>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
            };
        },
        mounted() {
            this.$Progress.start();
			this.listMyPayment();
        },
        methods: {
            listMyPayment: function(){
				var that = this;
				$('#myPaymentsTable').DataTable({
                    sDom: '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
					processing: true,
					serverSide: true,
					ordering: false,
					ajax: {
						"url": "api/listMyPayment",
						"headers": window.axios.defaults.headers.common,
						"dataSrc": "records",
					},
					deferRender: true,
					columns: [
						{data: 'id', visible: false},
						{render: function(data,type,full){
							if(full.user != null){
								return full.user.name;
							}else{
								return "---";
							}
						}},
						{render: function(data,type,full){
							var obj = JSON.parse(full.breakUp);
							var basic_salary, housing_allowance, medical_allowance, car_allowance, fuel_allowance, other_allowance;
							if(obj.basic_salary) {
								basic_salary = obj.basic_salary;
							} else {
								basic_salary = 0;
							}
							if(obj.housing_allowance) {
								housing_allowance = obj.housing_allowance;
							} else {
								housing_allowance = 0;
							}
							if(obj.medical_allowance) {
								medical_allowance = obj.medical_allowance;
							} else {
								medical_allowance = 0;
							}
							if(obj.car_allowance) {
								car_allowance = obj.car_allowance;
							} else {
								car_allowance = 0;
							}
							if(obj.fuel_allowance) {
								fuel_allowance = obj.fuel_allowance;
							} else {
								fuel_allowance = 0;
							}
							if(obj.other_allowance) {
								other_allowance = obj.other_allowance;
							} else {
								other_allowance = 0;
							}
							var total_salary = parseInt(basic_salary) + parseInt(housing_allowance) + parseInt(medical_allowance) + parseInt(car_allowance) + parseInt(fuel_allowance) + parseInt(other_allowance);
							var total_salary = new Intl.NumberFormat().format(total_salary);
							if(total_salary == 0){
								return '---';
							}else{
								return total_salary;
							}
						}},
						{render: function(data,type,full){
							var obj = JSON.parse(full.breakUp);
							var overtime, bonus, commission, other_additional_earning;
							if(obj.overtime) {
								overtime = obj.overtime;
							} else {
								overtime = 0;
							}
							if(obj.bonus) {
								bonus = obj.bonus;
							} else {
								bonus = 0;
							}
							if(obj.commission) {
								commission = obj.commission;
							} else {
								commission = 0;
							}
							if(obj.other_additional_earning) {
								other_additional_earning = obj.other_additional_earning;
							} else {
								other_additional_earning = 0;
							}
							var total_additional_earning = parseInt(overtime) + parseInt(bonus) + parseInt(commission) + parseInt(other_additional_earning);
							var total_additional_earning = new Intl.NumberFormat().format(total_additional_earning);
							if(total_additional_earning == 0){
								return '---';
							}else{
								return total_additional_earning;
							}
						}},
						{render: function(data,type,full){
							var obj = JSON.parse(full.breakUp);
							var fuelreimbursement, travelingreimbursement, reimbursements;
							if(obj.fuelreimbursement) {
								fuelreimbursement = obj.fuelreimbursement;
							} else {
								fuelreimbursement = 0;
							}
							if(obj.travelingreimbursement) {
								travelingreimbursement = obj.travelingreimbursement;
							} else {
								travelingreimbursement = 0;
							}
							if(obj.reimbursements) {
								reimbursements = obj.reimbursements;
							} else {
								reimbursements = 0;
							}
							var totalreimbursement = parseInt(fuelreimbursement) + parseInt(travelingreimbursement) + parseInt(reimbursements);
							var totalreimbursement = new Intl.NumberFormat().format(totalreimbursement);
							if(totalreimbursement == 0){
								return '---';
							}else{
								return totalreimbursement;
							}
						}},
						{render: function(data,type,full){
							var obj = JSON.parse(full.breakUp);
							var income_tax, eobi, provident_fund, other_deduction, outstanding_advance_salary, fees_advance_salary;
							if(obj.income_tax) {
								income_tax = obj.income_tax;
							} else {
								income_tax = 0;
							}
							if(obj.eobi) {
								eobi = obj.eobi;
							} else {
								eobi = 0;
							}
							if(obj.provident_fund) {
								provident_fund = obj.provident_fund;
							} else {
								provident_fund = 0;
							}
							if(obj.other_deduction) {
								other_deduction = obj.other_deduction;
							} else {
								other_deduction = 0;
							}
							if(obj.outstanding_advance_salary) {
								outstanding_advance_salary = obj.outstanding_advance_salary;
							} else {
								outstanding_advance_salary = 0;
							}
							if(obj.fees_advance_salary) {
								fees_advance_salary = obj.fees_advance_salary;
							} else {
								fees_advance_salary = 0;
							}
							var deduction = parseInt(income_tax) + parseInt(eobi) + parseInt(provident_fund) + parseInt(other_deduction) + parseInt(outstanding_advance_salary) + parseInt(fees_advance_salary);
							var deduction = new Intl.NumberFormat().format(deduction);
							if(deduction == 0){
								return '---';
							}else{
								return deduction;
							}
						}},
						{render: function(data,type,full){
							var transactionId = full.transactionId;
							var transactionNo = full.transactionId;
							var status = full.batchreason;
							var to_return = '<div class="image-title employe-detail-tooltip" data-toggle="tooltip"><div class="image-holder"><img src="assets/images/table-dummy-image.jpg" alt="" /></div><a href="#" class="title"> Jawad Amjad </a></div>';
							return transactionId;
						}},
						{render: function(data,type,full){
							var net_salary = new Intl.NumberFormat().format(full.net_salary);
							if(net_salary != null){
								return net_salary;
							}
						}},
						{render: function(data,type,full){
							var date = full['created_at'];
							return ''+moment(date).format('MMM D, Y')+'';
						}},
						{data: 'id', sorting: false, render: function(data,type,full){
							return '<a href="javascript:void(0);" data-toggle="tooltip" data-placement="top" title="Download" class="action" onclick="VueComponents.myPaymentComponent.methods.downloadSalarySlip('+full['id']+')" ><i class="fas fa-download"></i></a>';
						}}
					],
					"order": [[ 0, "desc" ]],
					"initComplete": () => {
						this.$Progress.finish();
					}
				});
            },
            downloadSalarySlip: function(id){
                axios.get('/api/downloadMySalarySlip/'+id, {responseType: 'arraybuffer'})
                .then((response) => {
                    if(response.status == 200){
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = 'Salary Slip.pdf'
                        link.click();
                        toast.fire({
                            type: 'success',
                            title: 'File Downloaded Successfully'
                        });
                    }else{
                        swal.fire({
                            type: 'error',
                            title: 'Something Went Wrong Please Try Again'
                        });
                    }

                });
            }
        }

    }
</script>
